/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Asset Type and Project ID that is used for filtering.
 *
 */
export var AssetFaultTypePropertyForFiltering;
(function (AssetFaultTypePropertyForFiltering) {
    AssetFaultTypePropertyForFiltering["ASSET_SOURCE_TYPE"] = "assetSourceType";
    AssetFaultTypePropertyForFiltering["ASSET_ID"] = "assetId";
    AssetFaultTypePropertyForFiltering["PROJECT_ID"] = "projectId";
})(AssetFaultTypePropertyForFiltering || (AssetFaultTypePropertyForFiltering = {}));
